import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Pages from "./pages";
import { history } from "./index";
import Authorization from "./components/authorization";
import { PDFCO_APP_URL } from "./constants/common";
import { useEffect, useMemo } from "react";
import Cookies from "universal-cookie";

function App() {
  const basename = useMemo(() => {
    if (
      ["/pdf-edit-add-helper", "/pdf-inspector"].includes(
        window.location.pathname
      )
    ) {
      return window.location.pathname;
    }

    return PDFCO_APP_URL;
  }, []);

  const cookies = new Cookies();

  useEffect(() => {
    const hasToken = Boolean(cookies.get("token"));
    if (!hasToken) {
      window.location.href = "https://app.pdf.co/login";
    }
  }, []);

  if (!cookies.get("token")) {
    return null;
  }

  return (
    <BrowserRouter basename={basename} history={history}>
      <Authorization />
      <Pages />
    </BrowserRouter>
  );
}

export default App;
